export function initialTargetFaceSelection(faces) {
  const normalizedFaces = Array.isArray(faces) ? faces : []
  if (normalizedFaces.length === 1) {
    return { mode: "index", targetFaceIndex: Number(normalizedFaces[0].index) }
  }
  return { mode: "auto", targetFaceIndex: null }
}

export function normalizeDetectedFaces(faces) {
  return Array.isArray(faces) ? faces : []
}

export function selectTargetFace(faces, mode, targetFaceIndex = null) {
  if (!["auto", "all", "index"].includes(mode)) return null
  if (mode !== "index") return { mode, targetFaceIndex: null }

  const index = Number(targetFaceIndex)
  if (!(Array.isArray(faces) ? faces : []).some((face) => Number(face.index) === index)) return null
  return { mode: "index", targetFaceIndex: index }
}

export function serializeTargetFaceSelections(entries) {
  return entries.map((entry) => {
    if (!entry.pickerImage) return null
    const selection = { token: entry.token, mode: entry.mode }
    if (entry.mode === "index") selection.target_face_index = entry.targetFaceIndex
    return selection
  })
}

export function serializeTargetPickerSubmission(entries) {
  const uploadedEntries = entries.filter((entry) => entry.signedId)

  return {
    signedIds: uploadedEntries.map((entry) => entry.signedId),
    selections: serializeTargetFaceSelections(uploadedEntries)
  }
}

export function currentDetectionResponse(expectedRequestId, responseRequestId, removed = false) {
  return !removed && expectedRequestId === responseRequestId
}
